import React, { useState, useEffect } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Alert, Button, Col, Form, Row, Spinner, Table } from "react-bootstrap";
import { authFetch } from "../utils/authFetch";

const dateValue = date => `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`;
const money = value => Number(value).toLocaleString("ro-RO", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
const formatDate = isoStr => {
  if (!isoStr) return "";
  const parts = isoStr.split("-");
  if (parts.length === 3) return `${parts[2]}/${parts[1]}/${parts[0]}`;
  return isoStr;
};


export default function RaportManoperaProd() {
  const [start, setStart] = useState(() => new Date(new Date().getFullYear(), new Date().getMonth(), 1));
  const [end, setEnd] = useState(() => new Date());
  const [employeeId, setEmployeeId] = useState("");
  const [employees, setEmployees] = useState([]);
  const [report, setReport] = useState(null);
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    let active = true;
    authFetch("/angajati/?include_inactive=true").then(data => { if (active) setEmployees(data); }).catch(err => { if (active) setError(err.message); });
    return () => { active = false; };
  }, []);

  const load = async event => {
    event.preventDefault(); 
    setError(""); 
    setReport(null);
    if (!start || !end || start > end) { setError("Alege un interval de date valid."); return; }
    setBusy(true);
    try {
      const params = new URLSearchParams({ data_start: dateValue(start), data_end: dateValue(end) });
      if (employeeId) params.set("angajat_id", employeeId);
      // Backend endpoint to implement:
      setReport(await authFetch(`/comenzi-prod/rapoarte/manopera?${params}`));
    } catch (err) { setError(err.message); }
    finally { setBusy(false); }
  };

  return (
    <div className="bg-white p-3 rounded shadow-sm">
      <p className="text-muted">Afișează manopera repartizată pe angajați și comenzi de producție. Intervalul se aplică datei lansării comenzii.</p>
      
      <Form onSubmit={load} className="d-print-none mb-4">
        <fieldset disabled={busy}>
          <Row className="g-3 align-items-end">
            <Col md={3}>
              <Form.Group>
                <Form.Label>De la</Form.Label>
                <DatePicker selected={start} onChange={date => setStart(date)} dateFormat="dd/MM/yyyy" className="form-control" />
              </Form.Group>
            </Col>
            <Col md={3}>
              <Form.Group>
                <Form.Label>Până la</Form.Label>
                <DatePicker selected={end} onChange={date => setEnd(date)} dateFormat="dd/MM/yyyy" className="form-control" />
              </Form.Group>
            </Col>
            <Col md={4}>
              <Form.Group>
                <Form.Label>Angajat</Form.Label>
                <Form.Select value={employeeId} onChange={e => setEmployeeId(e.target.value)}>
                  <option value="">Toți angajații</option>
                  {employees.map(item => <option key={item.id} value={item.id}>{item.nume_prenume}{item.activ ? "" : " (inactiv)"}</option>)}
                </Form.Select>
              </Form.Group>
            </Col>
            <Col>
              <Button type="submit" variant="primary">Afișează</Button>
            </Col>
          </Row>
        </fieldset>
      </Form>

      {error && <Alert variant="danger">{error}</Alert>}
      {busy && <Spinner animation="border" />}

      {report && (
        <>
          <div className="d-flex justify-content-between align-items-center mb-3">
            <strong>Perioada: {formatDate(report.data_start)} - {formatDate(report.data_end)}</strong>
            <Button variant="outline-secondary" size="sm" onClick={() => window.print()} className="d-print-none">Tipărește</Button>
          </div>
          
          {!report.items.length ? (
            <Alert variant="info">Nu s-a înregistrat manoperă în perioada selectată.</Alert>
          ) : (
            <Table bordered hover responsive size="sm" className="align-middle">
              <thead className="table-light">
                <tr>
                  <th>Angajat</th>
                  <th>Operațiune / Comandă</th>
                  <th className="text-end">Timp Alocat (ore)</th>
                  <th className="text-end">Cost Total (lei)</th>
                </tr>
              </thead>
              <tbody>
                {report.items.map(ang => (
                  <React.Fragment key={ang.angajat_id}>
                    <tr className="table-secondary">
                      <td colSpan={4} className="fw-bold">{ang.angajat}</td>
                    </tr>
                    {ang.comenzi.map((cmd, idx) => (
                      <tr key={idx}>
                        <td></td>
                        <td>
                          <div><strong>{cmd.numar_document}</strong> {cmd.data ? `(${formatDate(cmd.data)})` : ""}</div>
                          <small className="text-muted">{cmd.operatiune}</small>
                        </td>
                        <td className="text-end">{Number(cmd.timp_alocat).toFixed(2)}h</td>
                        <td className="text-end fw-semibold">{money(cmd.cost)}</td>
                      </tr>
                    ))}
                    <tr>
                      <td colSpan={2} className="text-end fw-bold">Total {ang.angajat}:</td>
                      <td className="text-end fw-bold">{Number(ang.total_timp).toFixed(2)}h</td>
                      <td className="text-end fw-bold text-success">{money(ang.total_cost)}</td>
                    </tr>
                  </React.Fragment>
                ))}
                <tr className="table-dark">
                  <td colSpan={3} className="text-end fs-5">TOTAL GENERAL:</td>
                  <td className="text-end fs-5 text-warning">{money(report.total_general)}</td>
                </tr>
              </tbody>
            </Table>
          )}
        </>
      )}
    </div>
  );
}
